import createIcon from '../../createIcon';

/**
 * @component @name BorderAll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAzVjIxSDIxVjNIM1pNMTEgMTlINVYxM0gxMVYxOVpNMTEgMTFINVY1SDExVjExWk0xOSAxOUgxM1YxM0gxOVYxOVpNMTkgMTFIMTNWNUgxOVYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderAll = createIcon('BorderAll', [
  [
    'path',
    {
      d: 'M3 3V21H21V3H3ZM11 19H5V13H11V19ZM11 11H5V5H11V11ZM19 19H13V13H19V19ZM19 11H13V5H19V11Z',
      key: '1v0nps',
    },
  ],
]);

export default BorderAll;
